<template>
	<c-dialog ref="dialog" :title="fill ? '批量填充' : '批量编辑'" width="500" height="200" @resolve="submitHandle">
		<c-form ref="form" unit-width="100%">
			<c-form-item label="目标字段" required>
				<c-select v-model="fieldId" ref="field" name="field_id" async @search="searchField" @change="parseField"></c-select>
			</c-form-item>
			<c-form-item ref="valueItem" label="修改为" :required="fieldConfig.required" name="value">
				<template v-if="fieldType == 'text'">
					<c-input v-model="value" :type="fieldConfig.type" placeholder="请输入" :height-resize="{type: 'auto', maxHeight: '100px'}"></c-input>
				</template>
				<template v-else-if="fieldType == 'number'">
					<c-input v-model="value" type="stepper" :decimal="fieldConfig.decimal" :range="fieldConfig.range" placeholder="请输入"></c-input>
				</template>
				<template v-else-if="fieldType == 'time'">
					<c-datetime v-model="value"
						:type="fieldConfig.type"
						:format="fieldConfig.format"
						:time-accuracy="fieldConfig.timeAccuracy"
					></c-datetime>
				</template>
				<template v-else-if="fieldType == 'option'">
					<c-select
						v-model="value"
						:search="{add: fieldConfig.add}"
						:options="fieldConfig.options"
						:multiple="fieldConfig.multiple"
						@add="addCustomOption($refs.field.getData(), arguments[0], arguments[1], arguments[2])"
					></c-select>
				</template>
				<template v-else-if="fieldType == 'file'">
					<c-upload-file
						v-model="value"
						:type="fieldConfig.type"
						:multiple="fieldConfig.multiple ? 30 : false"
					></c-upload-file>
				</template>
				<template v-else-if="fieldType == 'image'">
					<c-upload-file
						v-model="value"
						type="image"
						media
						:multiple="fieldConfig.multiple ? 30 : false"
						:side="false"
						:sort="false"
						media-icon="tf-plus"
					></c-upload-file>
				</template>
				<template v-else-if="fieldType == 'rel_object'">
					<c-select
						v-model="value"
						ref="objectFieldValue"
						async
						@search="searchObjectOption"
					></c-select>
				</template>
				<template v-else>
					<c-input disabled placeholder="请选择目标字段"></c-input>
				</template>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
	import dictList from '@/store/dict.js'

	export default {
		name: 'workFieldEdit',
		
		props: {
			fill: Boolean,
			workType: [String, Number],
			viewId: [String, Number]
		},

		data() {
			return {
				fieldId: '',
				fieldType: 0,
				fieldConfig: {},
				value: ''
			}
		},

		methods: {
			open(ids) {
				this._ids = ids;
				this.$refs.form.clear();
				this.reset();
				this.$refs.dialog.open();
			},

			reset() {
				this.fieldType = 0;
				this.$refs.valueItem.warn(false);
			},

			searchField(keyword, resolve) {
				this.request({
					url: '/sys_field/batch/editable/list',
					data: {
						view_id: this.viewId,
						keyword: keyword
					},
					success: data => {
						resolve(data.filter(item => {
							return item.field_type != 9 || (!item.config_json.attr.includes('readonly') && !['formula'].includes(item.config_json.type));
						}).map(item => {
							item.config_json.field_config = item.config_json.field_config || {};
							return {
								name: item.field_title,
								value: item.id,
								data: item
							}
						}));
					}
				})
			},

			parseField({data: field}) {
				this.reset();
				this.$nextTick(() => {
					this.fieldType = field.field_type == 9
						? field.config_json.type
						: {
							1: 'text',
							2: 'number',
							3: 'time',
							4: 'option',
							5: 'file',
							6: 'image'
						}[field.field_type]

					this.fieldConfig = {
						required: field.field_type == 9 ? field.config_json.attr.includes('required') : field.is_required == 1
					};
					this.value = '';

					if (this.fieldType == 'text') {
						this.$set(this.fieldConfig, 'type', field.field_type == 9 && field.config_json.attr.includes('textarea')
							? 'textarea'
							: (field.config_json.field_config.textarea ? 'textarea' : 'text')
						);
					} else if (this.fieldType == 'number') {
						this.$set(this.fieldConfig, 'decimal', field.field_type == 9
							? field.config_json.decimal
							: (field.config_json.field_config.decimal || 6)
						);
						this.$set(this.fieldConfig, 'range', [1 / Math.pow(10, this.fieldConfig.decimal), 99999999]);
						
					} else if (this.fieldType == 'time') {
						if (field.field_type == 9) {
							let format = field.config_json.format.split('|');
							this.$set(this.fieldConfig, 'type', format[1]);
							this.$set(this.fieldConfig, 'format', format[0]);
							this.$set(this.fieldConfig, 'timeAccuracy', format[2]);
						} else {
							this.$set(this.fieldConfig, 'type', 'datetime');
							this.$set(this.fieldConfig, 'format', 'yyyy-MM-dd hh:mm');
							this.$set(this.fieldConfig, 'timeAccuracy', 'min');
						}
					} else if (this.fieldType == 'option') {
						if (field.field_type == 9) {
							this.$set(this.fieldConfig, 'options', field.config_json.options);
							this.$set(this.fieldConfig, 'multiple', field.config_json.attr.includes('multiple'));
							this.$set(this.fieldConfig, 'add', field.config_json.attr.includes('add'));
						} else if (field.config_json.dict_config.dictType == 'PAGEDIC') {
							this.$set(this.fieldConfig, 'options', dictList[field.config_json.dict_config.dictName]);
						} else if (field.config_json.dict_config.dictType == 'DBDIC') {
							this.request({
								url: '/system/options',
								data: {
									options_code: field.config_json.dict_config.dictName
								},
								success: data => {
									if (field.config_json.dict_config.dictName == 'SYSUSER') {
										data.unshift({
											name: '当前登录用户',
											value: '#curr_login_user_id#'
										});
									}
									this.$set(this.fieldConfig, 'options', data);
								}
							})
						}
					} else if (this.fieldType == 'file') {
						this.$set(this.fieldConfig, 'type', field.field_type == 9 ? field.config_json.suffix.join(',') : '');
						this.$set(this.fieldConfig, 'multiple', field.field_type == 9 ? field.config_json.attr.includes('multiple') : false);
					} else if (this.fieldType == 'image') {
						this.$set(this.fieldConfig, 'type', 'image');
						this.$set(this.fieldConfig, 'multiple', field.field_type == 9 ? field.config_json.attr.includes('multiple') : false);
					}
				});
			},

			addCustomOption({data}, event, name, resolve) {
				let option = {
					name,
					value: name
				}
				this.request({
					url: '/sys_field/edit',
					data: {
						id: data.id,
						field_title: data.field_title,
						config_json: JSON.stringify(Object.assign({}, data.config_json, {
							options: data.config_json.options.map(item => item).concat([option])
						}))
					},
					loading: true,
					success: () => {
						resolve(option);
					}
				});
			},

			searchObjectOption(keyword, resolve) {
				this.request({
					url: '/sys_field/relation/data_list',
					data: {
						relation_field_id: this.fieldId,
						keyword
					},
					success: data => {
						resolve(data.map(item => {
							return {
								name: item.display_value,
								value: item.id
							}
						}))
					}
				})
			},

			submitHandle(stop, next) {
				stop();
				this.$refs.form.validate({
					rule: {
						field_id: '请选择目标字段',
						value: [{
							type: 'function',
							message: '要修改的值不能为空',
							fun: () => {
								return !this.fieldConfig.required || (Array.isArray(this.value) ? this.value.length : (this.value || this.value === 0));
							}
						}]
					},
					success: data => {
						if (this.fill) {
							let field = this.$refs.field.getData().data;
							next();
							this.$emit('resolve', {
								field,
								value: this.value,
								extend: {
									objectFieldValue: this.$refs.objectFieldValue ? this.$refs.objectFieldValue.getData() : ''
								}
							});
						} else {
							this.request({
								url: '/batch/modify',
								data: Object.assign(data, {
									work_type_id: this.workType,
									data_list: this._ids.map(id => {
										return {
											id,
											value: this.value
										}
									})
								}),
								loading: true,
								success: () => {
									this.$message({
										message: '批量编辑成功'
									});
									next();
									this.$emit('resolve');
								}
							})
						}
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
